import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "rounded bg-white p-3 mb-4" };
const _hoisted_2 = { class: "d-flex justify-content-end" };
const _hoisted_3 = { class: "d-flex flex-wrap" };
const _hoisted_4 = {
    class: "modal fade",
    id: "create",
    tabindex: "-1",
    "aria-labelledby": "createModalLabel",
    "aria-hidden": "true"
};
const _hoisted_5 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_6 = { class: "modal-content" };
const _hoisted_7 = { class: "modal-body" };
const _hoisted_8 = { class: "form-floating mb-3" };
const _hoisted_9 = { class: "form-floating mb-3" };
const _hoisted_10 = ["value"];
const _hoisted_11 = { class: "form-check mb-3" };
const _hoisted_12 = { class: "form-check mb-3" };
const _hoisted_13 = { class: "form-floating mb-3" };
const _hoisted_14 = { class: "form-floating" };
const _hoisted_15 = { class: "form-floating mb-3" };
const _hoisted_16 = ["value"];
import { FilterMatchMode } from '@primevue/core/api';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, Link, useForm } from '@inertiajs/vue3';
import { ref } from 'vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { Modal } from 'bootstrap';
import YesNoIcon from '@/Shared/YesNoIcon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Index',
    props: {
        modelTypes: Object,
        defaultPriceBundles: Object,
        priceBundles: Object,
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatDate } = formatters();
        const props = __props;
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const createDefaultPriceBundle = useForm({
            modelType: null,
            name: null,
            isApi: true,
            isColoring: true,
            colors: null,
            volume: null,
            priceBundleUuid: null
        });
        function create() {
            createDefaultPriceBundle.transform((data) => ({
                modelType: data.modelType,
                name: data.name,
                isApi: data.isApi,
                isColoring: data.isColoring,
                volume: data.volume,
                colors: data.colors
            }))
                .submit('post', route('admin.priceBundles.defaults.store', createDefaultPriceBundle.priceBundleUuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    const modal = Modal.getInstance(document.getElementById('create'));
                    modal.hide();
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Default-Preis-Bundles" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _cache[13] || (_cache[13] = _createElementVNode("h1", { class: "fw-bold mb-3" }, "Default-Preis-Bundles", -1)),
                        _createElementVNode("div", _hoisted_1, [
                            _cache[12] || (_cache[12] = _createElementVNode("button", {
                                class: "btn btn-secondary d-inline-flex align-items-center",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#create"
                            }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    class: "bi bi-plus-lg",
                                    viewBox: "0 0 16 16"
                                }, [
                                    _createElementVNode("path", {
                                        "fill-rule": "evenodd",
                                        d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                    })
                                ]),
                                _createElementVNode("span", { class: "ms-2" }, "Neuer Default")
                            ], -1)),
                            _createVNode(_unref(DataTable), {
                                dataKey: "id",
                                value: props.defaultPriceBundles,
                                stripedRows: "",
                                responsiveLayout: "scroll",
                                globalFilterFields: ['name', 'modelType', 'colors', 'createdAt', 'updatedAt'],
                                filters: tableFilter.value,
                                "onUpdate:filters": _cache[1] || (_cache[1] = ($event) => ((tableFilter).value = $event)),
                                paginator: true,
                                rows: 10,
                                paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                                rowsPerPageOptions: [10, 25, 50, 150],
                                currentPageReportTemplate: "{first} von {last} von insgesamt {totalRecords}"
                            }, {
                                header: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((tableFilter.value['global'].value) = $event)),
                                            placeholder: "Suche",
                                            style: { "width": "250px" }
                                        }, null, 512), [
                                            [_vModelText, tableFilter.value['global'].value]
                                        ])
                                    ])
                                ]),
                                empty: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                        _createElementVNode("div", { class: "p-3" }, " Keine Einträge gefunden ", -1)
                                    ]))]),
                                loading: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                        _createTextVNode(" Einträge werden geladen ... ", -1)
                                    ]))]),
                                default: _withCtx(() => [
                                    _createVNode(_unref(Column), {
                                        header: "#",
                                        sortable: true
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Name",
                                        sortable: true,
                                        sortField: "name"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createVNode(_unref(Link), {
                                                href: _ctx.route('admin.priceBundles.defaults.edit', slotProps.data.uuid)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(slotProps.data.name), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["href"])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Typ",
                                        field: "modelType",
                                        sortable: true,
                                        sortField: "modelType"
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Api-Default",
                                        sortable: true,
                                        sortField: "isApi"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createVNode(YesNoIcon, {
                                                answer: slotProps.data.isApi
                                            }, null, 8, ["answer"])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Druck-Default",
                                        sortable: true,
                                        sortField: "isColoring"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createVNode(YesNoIcon, {
                                                answer: slotProps.data.isColoring
                                            }, null, 8, ["answer"])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Farben",
                                        sortable: true,
                                        sortField: "colors"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(slotProps.data.colors === 0 ? 'Digitaldruck' : slotProps.data.colors), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Preis-Bundle",
                                        field: "priceBundle.name",
                                        sortable: true,
                                        sortField: "priceBundle.name"
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Letzte Änderung",
                                        sortable: true,
                                        sortField: "updatedAt"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.updatedAt, true)), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Erstellt",
                                        sortable: true,
                                        sortField: "createdAt"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.createdAt, true)), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), { header: "" }, {
                                        body: _withCtx((slotProps) => [
                                            _createElementVNode("div", _hoisted_3, [
                                                _createVNode(_unref(Link), {
                                                    href: _ctx.route('admin.priceBundles.defaults.edit', slotProps.data.uuid),
                                                    class: "btn btn-primary d-inline-flex align-items-center"
                                                }, {
                                                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                            _createElementVNode("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                width: "16",
                                                                height: "16",
                                                                fill: "currentColor",
                                                                class: "bi bi-pencil-square text-white",
                                                                viewBox: "0 0 16 16"
                                                            }, [
                                                                _createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
                                                                _createElementVNode("path", {
                                                                    "fill-rule": "evenodd",
                                                                    d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                                                })
                                                            ], -1)
                                                        ]))]),
                                                    _: 1
                                                }, 8, ["href"])
                                            ])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["value", "filters"])
                        ])
                    ]),
                    _: 1
                }),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("h1", {
                                        class: "modal-title fs-5 fw-bold",
                                        id: "createModalLabel"
                                    }, "Neuer Default"),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    })
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(create, ["prevent"])
                                }, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("div", _hoisted_8, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "name",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(createDefaultPriceBundle).name) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(createDefaultPriceBundle).name]
                                            ]),
                                            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "name" }, "Name", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _withDirectives(_createElementVNode("select", {
                                                class: "form-select",
                                                id: "modelType",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(createDefaultPriceBundle).modelType) = $event)),
                                                required: ""
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.modelTypes, (modelType, index) => {
                                                    return (_openBlock(), _createElementBlock("option", { value: index }, _toDisplayString(modelType), 9, _hoisted_10));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, _unref(createDefaultPriceBundle).modelType]
                                            ]),
                                            _cache[15] || (_cache[15] = _createElementVNode("label", { for: "modelType" }, "Produkt-Typ", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "isApi",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(createDefaultPriceBundle).isApi) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _unref(createDefaultPriceBundle).isApi]
                                            ]),
                                            _cache[16] || (_cache[16] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "isApi"
                                            }, "API-Default", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_12, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "isColoring",
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(createDefaultPriceBundle).isColoring) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _unref(createDefaultPriceBundle).isColoring]
                                            ]),
                                            _cache[17] || (_cache[17] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "isColoring"
                                            }, "Druck-Default", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_13, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "colors",
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(createDefaultPriceBundle).colors) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(createDefaultPriceBundle).colors]
                                            ]),
                                            _cache[18] || (_cache[18] = _createElementVNode("label", { for: "colors" }, "Farb-Anzahl (0=Digitaldruck)", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "volumeRule",
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(createDefaultPriceBundle).volume) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(createDefaultPriceBundle).volume]
                                            ]),
                                            _cache[19] || (_cache[19] = _createElementVNode("label", { for: "volumeRule" }, "Volumen in ml (optionale Regel)", -1))
                                        ]),
                                        _cache[21] || (_cache[21] = _createElementVNode("p", { class: "form-text mb-3" }, "Optionale Regel für Flaschen", -1)),
                                        _createElementVNode("div", _hoisted_15, [
                                            _withDirectives(_createElementVNode("select", {
                                                class: "form-select",
                                                id: "priceBundle",
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(createDefaultPriceBundle).priceBundleUuid) = $event)),
                                                required: ""
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.priceBundles, (bundle) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: bundle.uuid
                                                    }, _toDisplayString(bundle.name), 9, _hoisted_16));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, _unref(createDefaultPriceBundle).priceBundleUuid]
                                            ]),
                                            _cache[20] || (_cache[20] = _createElementVNode("label", { for: "priceBundle" }, "Preis-Bundle", -1))
                                        ])
                                    ]),
                                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-secondary",
                                            "data-bs-dismiss": "modal"
                                        }, "Abbrechen"),
                                        _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ])
                                    ], -1))
                                ], 32)
                            ])
                        ])
                    ])
                ]))
            ], 64));
        };
    }
});
